import React, { useState, useEffect } from 'react';
import DatePicker from './DatePicker';
import './FilterPanel.css';

function FilterPanel({ onFilterChange, getBookings }) {
  const [pitches] = useState([
    { id: 1, name: 'Taylorstown Pitch' },
    { id: 2, name: 'Loughbeg Road Pitch' },
    { id: 3, name: 'Gym' }
  ]);
  
  const [sessionTypes] = useState([
    { id: 'Training', name: 'Training' },
    { id: 'Match', name: 'Match' },
    { id: 'Maintenance', name: 'Maintenance' },
    { id: 'Event', name: 'Event' }
  ]);
  
  const [selectedPitch, setSelectedPitch] = useState('');
  const [selectedDate, setSelectedDate] = useState('');
  const [selectedSessionType, setSelectedSessionType] = useState('');
  
  // Update parent component when filters change
  useEffect(() => {
    onFilterChange({
      pitch: selectedPitch,
      date: selectedDate,
      sessionType: selectedSessionType
    });
  }, [selectedPitch, selectedDate, selectedSessionType, onFilterChange]);

  const handlePitchChange = (e) => {
    setSelectedPitch(e.target.value);
  };
  
  const handleDateChange = (value) => {
    setSelectedDate(value);
  };
  
  const handleSessionTypeChange = (e) => {
    setSelectedSessionType(e.target.value);
  };
  
  const handleRefresh = () => {
    getBookings();
  };
  
  const clearAllFilters = () => {
    setSelectedPitch('');
    setSelectedDate('');
    setSelectedSessionType('');
  };
  
  return (
    <div className="filter-panel-container">
      <div className="filter-content">
        <div className="filter-group pitch-filter">
          <label htmlFor="pitch-select">Pitch</label>
          <select 
            id="pitch-select" 
            value={selectedPitch} 
            onChange={handlePitchChange}
            className="filter-select"
          >
            <option value="">All Pitches</option>
            {pitches.map(pitch => (
              <option key={pitch.id} value={pitch.id}>
                {pitch.name}
              </option>
            ))}
          </select>
        </div>
        
        <div className="filter-group date-filter">
          <DatePicker
            label="Date"
            value={selectedDate}
            onChange={handleDateChange}
            id="date-filter"
          />
        </div>
        
        <div className="filter-group session-type-filter">
          <label htmlFor="session-type-select">Session Type</label>
          <select
            id="session-type-select"
            value={selectedSessionType}
            onChange={handleSessionTypeChange}
            className="filter-select"
          >
            <option value="">All Session Types</option>
            {sessionTypes.map(type => (
              <option key={type.id} value={type.id}>
                {type.name}
              </option>
            ))}
          </select>
        </div>

        <div className="refresh-button-container">
          <button 
            className="refresh-button" 
            onClick={handleRefresh}
            aria-label="Refresh bookings"
          >
            <svg 
              xmlns="http://www.w3.org/2000/svg" 
              width="18" 
              height="18" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            >
              <path d="M21.5 2v6h-6M2.5 22v-6h6M2 11.5a10 10 0 0 1 18.8-4.3M22 12.5a10 10 0 0 1-18.8 4.3"/>
            </svg>
          </button>
        </div>
      </div>

      {(selectedPitch || selectedDate || selectedSessionType) && (
        <div className="filter-footer">
          <button
            type="button"
            className="clear-filters-button"
            onClick={clearAllFilters}
          >
            Clear filters
          </button>
        </div>
      )}
    </div>
  );
}

export default FilterPanel;